import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Constants from '../common/constants'
import router from './router'
import storePagination from '../common/storePagination'

Vue.use(Vuex)

// Make Axios play nice with Django CSRF
axios.defaults.xsrfCookieName = 'csrftoken'
axios.defaults.xsrfHeaderName = 'X-CSRFToken'

export default new Vuex.Store({
  modules: {
    pagination: storePagination
  },
  state: {
    authUser: localStorage.getItem('user'),
    userRole: localStorage.getItem('role'),
    jwt: localStorage.getItem('token'),
    icon: localStorage.getItem('icon'),
    club: localStorage.getItem('club'),
    draft: null,
    fichaId: 0,
    fichaAreas: [],
    globalInfo: '',
    errorMsg: '',
    activeArea: -1,
    activeSubarea: -1,
    permissions: {},
    miniLateralNav: true,
    notifications: [],
    showDraftNotification: false,
    pantallas: {}
  },

  mutations: {
    setAuthUser (state, username) {
      localStorage.setItem('user', username)
      state.authUser = username
    },
    setUserRole (state, role) {
      localStorage.setItem('role', role)
      state.userRole = role
    },
    setIcon (state, icon) {
      localStorage.setItem('icon', icon)
      state.icon = icon
    },
    setClub (state, nombre) {
      localStorage.setItem('club', nombre)
      state.club = nombre
    },
    setDraft (state, draft) {
      state.draft = draft
    },
    setActiveArea (state, id) {
      state.activeArea = id
    },
    setActiveSubarea (state, id) {
      state.activeSubarea = id
    },
    setPermissions (state, permissions) {
      state.permissions = permissions
    },
    setNotifications (state, notifications) {
      state.notifications = notifications
    },
    fetchDraft (state) {
      if (this.getters.isSafRole || !state.permissions.canViewDraft) return
      axios.defaults.headers.common['Authorization'] = `JWT ${state.jwt}`
      axios
        .get('/draft')
        .then(response => {
          if (response.status === 204) {
            state.draft = null
          } else {
            state.draft = response.data.draft
          }
        })
        .catch(error => { this.commit('setErrorMsg', error) })
    },
    updateToken (state, newToken) {
      localStorage.setItem('token', newToken)
      state.jwt = newToken
    },
    updateHeader (state) {
      if (state.jwt) {
        axios.defaults.headers.common['Authorization'] = `JWT ${state.jwt}`
      }
    },
    logout (state) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      localStorage.removeItem('role')
      localStorage.removeItem('icon')
      localStorage.removeItem('club')
      state.fichaAreas = []
      state.jwt = ''
      state.permissions = {}
      state.draft = null
      state.userRole = null
      axios.defaults.headers.common['Authorization'] = ''
    },
    cleanGlobalInfo (state) {
      state.globalInfo = ''
    },
    cleanErrorMsg (state) {
      state.errorMsg = ''
    },
    setCustomErrorMsg (state, msg) {
      state.errorMsg = 'Error: ' + msg
    },
    setErrorMsg (state, error) {
      if (!error || !error.response) return
      let data = error.response.data
      let msg
      if (data) {
        msg = data.hasOwnProperty('nonFieldErrors') ? data.nonFieldErrors[0] : msg
        msg = (data.hasOwnProperty('detail')) ? data.detail : msg
      }
      msg = (msg === undefined) ? 'error del servidor' : msg
      state.errorMsg = 'Error: ' + msg
    },
    changeLateralNav (state) {
      state.miniLateralNav = !state.miniLateralNav
    },
    hideLateralNav (state) {
      state.miniLateralNav = true
    },
    setMiniLateralNav (state, value) {
      state.miniLateralNav = value
    },
    setFichaId (state, id) {
      state.fichaId = id
    },
    setFichaAreas (state, areas) {
      state.fichaAreas = areas
    },
    changeshowDraftNotification (state, value) {
      state.showDraftNotification = value
    },
    setPantallas (state, pantallas) {
      state.pantallas = pantallas
    }
  },

  getters: {
    isLoggedIn: state => {
      return state.jwt
    },
    role: state => {
      return (parseInt(state.userRole) === Constants.ROLE_SAF) ? 'Saf' : 'Club'
    },
    isSafRole: state => {
      return parseInt(state.userRole) === Constants.ROLE_SAF
    },
    isClubRole: state => {
      return parseInt(state.userRole) === Constants.ROLE_CLUB
    },
    hasDraftInProgress: state => {
      return state.draft !== null
    },
    hasFocusFicha: state => {
      return state.fichaAreas.length
    },
    loading: state => {
      let role = parseInt(state.userRole)
      return (role !== Constants.ROLE_SAF) && (role !== Constants.ROLE_CLUB)
    },
    club: state => {
      return state.club
    },
    showDraftNotification: state => {
      return state.showDraftNotification
    }
  },

  actions: {
    fetchNotifications (context) {
      axios.defaults.headers.common['Authorization'] = `JWT ${context.state.jwt}`
      axios
        .get('notifications')
        .then(response => context.commit('setNotifications', response.data))
        .catch(error => { context.commit('setErrorMsg', error) })
    },
    fetchFichaClub ({ state, commit }, id) {
      axios.defaults.headers.common['Authorization'] = `JWT ${state.jwt}`
      axios
        .get(`ficha/clubes/${id}`)
        .then(response => {
          commit('setFichaId', id)
          commit('setClub', response.data.nombre)
          commit('setIcon', response.data.logo)
          commit('setFichaAreas', response.data.areas)
          if (router.currentRoute.params.hasOwnProperty('idSubarea')) return
          if ((state.fichaAreas.length !== 0)) {
            router.push({
              name: 'fichaClub',
              params: {
                idClub: id,
                idSubarea: state.fichaAreas[0].subareas[0].id
              }
            })
          } else {
            state.globalInfo = 'No hay información del club'
          }
        })
        .catch(error => { commit('setErrorMsg', error) })
    },
    fetchUserRole ({ state, commit }) {
      axios.defaults.headers.common['Authorization'] = `JWT ${state.jwt}`
      axios
        .get('role')
        .then(response => commit('setUserRole', response.data.role))
        .catch(error => { commit('setErrorMsg', error) })
    }
  }
})
